<template>
  <section class="inner">
    <h1 id="detailHd">NEWS</h1>
    <ul id="pankuzu" class="flex flex-left">
      <li><a href="/" class="opacity">ホーム</a></li>
      <li>ニュース一覧</li>
    </ul>
    <div id="detailInner">
      <ul id="archiveNavi" class="flex flex-center">
        <li><a href="/news" v-bind:class="{ selected: !queryYear }">ALL</a></li>
        <li v-for="(year, index) in years" :key="index">
          <a v-bind:href="'/news?year=' + year " v-bind:class="[queryYear === year ? 'selected' : '']">{{ year }}</a>
        </li>
      </ul>
      <ul>
        <li v-for="(news, index) in newsList" v-bind:key="index" class="newsItem">
          <router-link v-bind:to="{ name: 'NewsDetail', params: { path: news.path} }" class="flex opacity">
            <p class="newsItem-date">{{ news.formatDate }}</p>
            <p class="newsItem-txt">{{ news.title }}</p>
          </router-link>
        </li>
      </ul>
    </div>
    <ul id="pagination" class="flex flex-center">
      <li v-if="false && page > 1"><router-link v-bind:to="{ name: 'News', query: { year: queryYear, page: page - 1 } }" class="prev">&lt;</router-link></li>
      <li v-for="(_page, index) in pageMax" :key="index"><router-link v-bind:to="{ name: 'News', query: { year: queryYear, page: _page } }" v-bind:class="[page === _page ? 'selected' : '']">{{ _page }}</router-link></li>
      <li v-if="false && page < pageMax"><router-link v-bind:to="{ name: 'News', query: { year: queryYear, page: page + 1 } }" class="next">&gt;</router-link></li>
    </ul>
  </section>
</template>

<script>
import {News} from '../assets/js/news.js'
const news = new News()
const pageCount = 10
export default {
  name: 'News',
  data () {
    return {
      newsList: [],
      queryYear: null,
      page: 1,
      pageMax: 1,
      years: []
    }
  },
  created: function () {
    this.queryYear = this.getYearParam(this.$route.query.year)
    this.page = this.getPageParam(this.$route.query.page)
    this.newsList = this.getNewsList()
    this.years = this.getYears()
  },
  filters: {
  },
  methods: {
    getYears: function () {
      return news.list.map(function (news) {
        return news.date.getFullYear()
      })
        .filter((x, i, self) => self.indexOf(x) === i)
        .sort()
        .reverse()
    },
    getNewsList: function () {
      var newsList = news.list
      const queryYear = this.queryYear

      if (queryYear) {
        newsList = newsList.filter(function (news) {
          return news.date.getFullYear() === queryYear
        })
      }
      this.pageMax = Math.ceil(newsList.length / pageCount)
      const start = (this.page - 1) * pageCount
      return newsList.slice(start, start + pageCount)
    },
    getYearParam: function (year) {
      const y = parseInt(year)
      return y && this.getYears().includes(y) ? y : null
    },
    getPageParam: function (page) {
      const p = parseInt(page)
      return p && p > 0 ? p : 1
    }
  },
  beforeRouteEnter: function (to, from, next) {
    next()
  },
  beforeRouteUpdate (to, from, next) {
    this.queryYear = this.getYearParam(to.query.year)
    this.page = this.getPageParam(to.query.page)
    this.newsList = this.getNewsList()
    next()
  },
  watch: {
  }
}
</script>

<style scoped>
  #archiveNavi{
    width:100%;
    margin-bottom:55px;
  }

  #archiveNavi li{
    width:72px;
    height:72px;
  }

  #archiveNavi li + li{ margin-left:14px;}

  #archiveNavi a{
    display:block;
    width:100%;
    height:100%;
    text-align:center;
    line-height:72px;
    color:#000;
    font-size:159%;
    font-family: 'TTNorms';
    font-weight:bold;
    background:#fff;
    transition:all 0.2s ease-out;
  }

  #archiveNavi a:hover,
  #archiveNavi .selected{ background:#F3D22D;}

  .newsItem + .newsItem{ margin-top:55px;}

  .newsItem-txt{
    width:calc(100% - 136px);
    padding:1px 0;
    font-size:134%;
    line-height:1.75;
    color:#000;
  }

  #pagination{
    width:100%;
    margin-top:80px;
  }

  #pagination li{
    text-align:center;
    line-height:44px;
  }

  #pagination li + li{ margin-left:14px;}

  #pagination a{
    display:block;
    width:42px;
    height:42px;
    background:#fff;
    font-size:134%;
    line-height:40px;
    font-family: 'TTNorms';
    font-weight:bold;
    color:#231815;
    border:1px solid #231815;
    transition:all 0.2s ease-out;
  }

  #pagination .selected,
  #pagination a:hover{
    color:#fff;
    background:#231815;
  }

  #pagination .prev,
  #pagination .next{
    text-indent:-9999px;
    position:relative;
  }

  #pagination .prev::before,
  #pagination .next::before{
    display: block;
    content: "";
    width: 9px;
    height: 9px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: rotate(45deg) translateX(-50%);
    transition:all 0.2s ease-out;
  }

  #pagination .prev::before{
    border-left: 1px solid #000;
    border-bottom: 1px solid #000;
    margin-top: -1px;
  }

  #pagination .next::before{
    border-top: 1px solid #000;
    border-right: 1px solid #000;
    margin:-1px 0 0 -3px;
  }

  #pagination .prev:hover::before{
    border-left: 1px solid #fff;
    border-bottom: 1px solid #fff;
  }

  #pagination .next:hover::before{
    border-top: 1px solid #fff;
    border-right: 1px solid #fff;
  }

  /*------------------------------------------------------------
      MediaQuery
  ------------------------------------------------------------*/

  /* PC */
  @media screen and (max-width: 1180px) and (min-width: 835px){

    #archiveNavi{ margin-bottom:4.661016949152542vw;}

    #archiveNavi li{
      width:6.101694915254237vw;
      height:6.101694915254237vw;
    }

    #archiveNavi li + li{ margin-left:1.186440677966102vw;}

    #archiveNavi a{
      line-height:6.101694915254237vw;
      font-size:1.610169491525424vw;
    }

    .newsItem + .newsItem{ margin-top:4.661016949152542vw;}

    .newsItem-txt{
      width:calc(100% - 11.52542372881356vw);
      padding:0.0847457627118644vw 0;
      font-size:1.355932203389831vw;
    }

    #pagination{ margin-top:6.779661016949153vw;}
    #pagination li{ line-height:3.728813559322034vw;}
    #pagination li + li{ margin-left:1.186440677966102vw;}

    #pagination a{
      width:3.559322033898305vw;
      height:3.559322033898305vw;
      font-size:1.355932203389831vw;
      line-height:3.559322033898305vw;
    }

    #pagination .prev::before,
    #pagination .next::before{
      width: 0.7627118644067797vw;
      height: 0.7627118644067797vw;
    }

    #pagination .prev::before{ margin-top: -0.0847457627118644vw;}
    #pagination .next::before{ margin:-0.0847457627118644vw 0 0 -0.2542372881355932vw;}
  }

  /* TABLET */
  @media screen and (max-width: 834px){

    #archiveNavi{ margin-bottom:40px;}

    #archiveNavi li{
      width:60px;
      height:60px;
    }

    #archiveNavi li + li{ margin-left:10px;}

    #archiveNavi a{
      line-height:60px;
      font-size:142%;
    }

    /*.newsItem + .newsItem{ margin-top:40px;}*/

    .newsItem-txt{
      width:calc(100% - 116px);
      font-size:117%;
    }

    #pagination{ margin-top:60px;}
  }

  /* SP */
  @media screen and (max-width: 480px){

    #archiveNavi{ margin-bottom:30px;}

    #archiveNavi li{
      width:84px;
      height:42px;
      margin: 0 0 7px 7px;
      text-align: left;
    }

    #archiveNavi li + li,
    #pagination li + li{ margin-left:7px;}

    #archiveNavi a{
      line-height:42px;
      font-size:117%;
    }

    .newsItem + .newsItem{ margin-top:16px;}

    .newsItem-txt{
      width:100%;
      font-size: 109%;
      margin-top: 10px;
    }

    #pagination{ margin-top:40px;}

    #pagination li{ line-height:36px;}

    #pagination a{
      width:36px;
      height:36px;
      font-size:117%;
      line-height:34px;
    }

    #pagination .prev::before,
    #pagination .next::before{
      width: 7px;
      height: 7px;
    }
  }
</style>
